export default __webpack_public_path__ + "static/media/Bezel_Red_White.02fa7709.png";